// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceList_container__27Cgd","card":"ServiceList_card__3_9kV","img":"ServiceList_img__l66hj","text":"ServiceList_text__2eNo3"};